// RegisterFace.js
import React, { useRef, useState } from 'react';
import axiosInstance from '../../services/AxiosInstance';

const RegisterFace = () => {
    const videoRef = useRef(null);
    const [images, setImages] = useState([]);
    const [isCameraStart, setIsCameraStart] = useState(false);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);

    const startCamera = async () => {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        videoRef.current.srcObject = stream;
        setIsCameraStart(true)
    };

    const captureImage = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 300;
        canvas.height = 300;
        canvas.getContext("2d").drawImage(videoRef.current, 0, 0, 300, 300);
        const dataUrl = canvas.toDataURL("image/jpeg");
        setImages(prev => [...prev, dataUrl]);
    };

    const submit = async () => {
        setIsSubmitLoading(true)
        const formData = new FormData();
        images.forEach(img => formData.append("images", img));
        try {
            const res = await axiosInstance.post("api/auth/register-face/", formData);
            console.log("rsposen", res)
            alert("Face registered successfully");
            setImages([]);
            videoRef.current.srcObject = null;
            setIsCameraStart(false)
        } catch (err) {
            console.error(err);
            alert("Error registering face");
        } finally {
            setIsSubmitLoading(false)
        }
    };

    return (
        <div className='card'>
            <div className='card-header'>
                <h2>Register Face</h2>
            </div>
            <div className='card-body'>
                <div className='d-flex align-items-center justify-content-center flex-column'>

                    <video ref={videoRef} autoPlay width="300" height="300" className='border rounded'>
                    </video>
                    <div className='my-2'>
                        {!isCameraStart ?
                            <button className='btn btn-sm btn-outline-primary' onClick={startCamera}>Start Camera</button>
                            :
                            <button className='btn btn-sm btn-success ' onClick={captureImage}>Capture</button>
                        }
                    </div>
                </div>

            </div>
            {images.length > 0 &&
                <div>
                    <h4>Captured Images</h4>
                    {images.map((img, i) => <img key={i} src={img} width={100} alt={`face-${i}`} />)}
                </div>
            }
            <div className='card-footer'>
                <button
                    disabled={images.length === 0 || isSubmitLoading}
                    className='btn btn-primary w-100' onClick={submit}>
                    Submit{isSubmitLoading && "ing..."}  Face Data</button>
            </div>
        </div>
    );
};

export default RegisterFace;
